export default {
	"plan": {
		"pickUpPeriod": "pickup period",
		"deliveryPeriod": "delivery period",
		"notPickup": "don't pick up the goods",
		"noDelivery": "delivery is not",
		"saveTransportOrderSort": "waybill order has been saved",
		"transfer": "transit",
		"revokeTransfer": "cancel the transfer",
		"notNeedPickUp": "the waybill does not need to pick up the goods",
		"canNotPickUp": "the waybill can pick up the goods",
		"notNeedDelivery": "this list does not need to delivery",
		"canNotDelivery": "this single delivery"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/plan/plan.js